import React, { useMemo } from "react";
import moment from "moment-timezone";
import { Label } from "../shadcn/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../shadcn/ui/select";
import { getUserTimezone } from "../utils/timezoneUtils";

/**
 * Get ALL IANA timezones from moment-timezone
 */
const getAllTimezones = () => {
  return moment.tz.names();
};

/**
 * Format timezone for display with UTC offset using moment-timezone
 */
const formatTimezoneLabel = timezone => {
  try {
    const offset = moment.tz(timezone).format("Z");
    return `${timezone.replace(/_/g, " ")} (UTC${offset})`;
  } catch (error) {
    return timezone.replace(/_/g, " ");
  }
};

/**
 * Timezone Select Component
 * @param {string} value - Selected timezone (IANA format)
 * @param {function} onChange - Callback when timezone changes
 * @param {string} label - Label for the select field
 * @param {boolean} required - Whether the field is required
 */
const TimezoneSelect = ({ value, onChange, label = "Timezone", required = false }) => {
  const timezones = useMemo(() => getAllTimezones(), []);
  const currentTimezone = value || getUserTimezone();

  return (
    <div className="space-y-1">
      <Label htmlFor="timezone">
        {label} {required && <span className="text-red-500">*</span>}
      </Label>
      <Select value={currentTimezone} onValueChange={onChange}>
        <SelectTrigger id="timezone" className="w-full">
          <SelectValue placeholder="Select timezone" />
        </SelectTrigger>
        <SelectContent className="max-h-[300px]">
          {timezones.map(tz => (
            <SelectItem key={tz} value={tz}>
              {formatTimezoneLabel(tz)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default TimezoneSelect;
